export default "__VITE_ASSET__ClE_VQ$M__"